/**
 * @private
 * @function
 * @description Initialize mqRes
 */
function mqRespondInit() {
    var mqRespond = new mqRes([
        {
            label: "mobile",
            from: 0,
            to: 767.9
        },
        {
            label: "tablet",
            from: 768,
            to: 1279.9
        },
        {
            label: "desktop",
            from: 1280,
            to: 1919.9
        },
        {
            label: "desktopLarge",
            from: 1920
        }
    ]);

    return mqRespond;
}

exports.init = mqRespondInit;
